/// <amd-module name="Repos/Tfvc/Views/FilesHub/Components/BlameContent" />
import * as React from "react";
import { IFilesHubFilterActionsService } from "Repos/FilesHubCommon/FilesHubFilterActionsService";
import * as Resources from "Repos/Tfvc/Views/FilesHub/Resources";
import { HeaderCommandBar } from "VSSUI/HeaderCommandBar";
import { registerFilesHubTab } from "../FilesHubViewService";
import { FileContent } from "./FileContent";

registerFilesHubTab({
    getTab: (pageContext, item, editMode) => {
        if (!item.isFolder && !item.isInvalid && !editMode) {
            const actionService = pageContext.getService<IFilesHubFilterActionsService>("IFilesHubFilterActionsService");

            return {
                id: "blame",
                name: Resources.Annotate,
                order: 40,
                render: () => <FileContent showAnnotate={true} />,
                renderFilterBar: (inTabBar: boolean) => {
                    return inTabBar ? <HeaderCommandBar items={actionService.getActions()} /> : undefined;
                }
            };
        }
    },
    dependencies: ["ms.vss-code-web.code-editor"]
});
